import { Component, ElementRef, Inject, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LEAD_BASED_PAINT } from '@shared/utils/app-static-data';
import { IAtp } from 'app/models/atp/atp';
import { IAtpPerson } from 'app/models/atp/atp-person';
import { IPerson } from 'app/models/people/person';
import { AtpService } from 'app/services/atp/atp.service';
import { PersonService } from 'app/services/person/person.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-atp-edit-staff',
  templateUrl: './atp-edit-staff.component.html',
  styleUrls: ['./atp-edit-staff.component.scss']
})
export class AtpEditStaffComponent {    
  public selectedPerson:IPerson;  
  public isContact:boolean = false;
  public isPrimaryInstructor:boolean = false;
  public isInstructor:boolean = false;
  public isTrainingManager:boolean = false;
  public uiData = LEAD_BASED_PAINT;  
  public atpPersonToAdd: IAtpPerson = {id: 0, person: null, atp: null, personType: null, isContact: false, isInstructor: false, isPrimaryInstructor: false, isTrainingManager: false};  

  constructor(private readonly dialogRef: MatDialogRef<AtpEditStaffComponent>,
    @Inject(MAT_DIALOG_DATA) public data:{currentPeople:IPerson [],atp:IAtp, person: IAtpPerson},
    public personService: PersonService,
    public atpService: AtpService,
    private readonly toastr: ToastrService,
    private readonly renderer: Renderer2, 
    private readonly el: ElementRef)  
  {        
    this.atpPersonToAdd.atp = this.data.atp;
    if(this.data.person !== undefined){      
      this.isContact = this.data.person.isContact;
      this.isInstructor = this.data.person.isInstructor;
      this.isPrimaryInstructor = this.data.person.isPrimaryInstructor;
      this.isTrainingManager = this.data.person.isTrainingManager;
      this.selectedPerson = this.data.person.person;
      this.atpPersonToAdd = this.data.person;      
    }    
  }  

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    this.saveATPMember();
  }

  saveATPMember(): void {
    this.atpPersonToAdd.person = this.selectedPerson;
    this.atpPersonToAdd.isContact = this.isContact;
    this.atpPersonToAdd.isInstructor = this.isInstructor;
    this.atpPersonToAdd.isPrimaryInstructor = this.isPrimaryInstructor;
    this.atpPersonToAdd.isTrainingManager = this.isTrainingManager;    
    this.atpService.saveATPPerson(this.atpPersonToAdd).subscribe(result=>{
      this.toastr.success("Successfully saved staff member")
      this.dialogRef.close(true);
    },error=>{
      this.toastr.error("An error occured saving the staff member: ", error);
    });      
  }

  updateScrollContainerHeight() {
    if (this.selectedPerson.id === 0) {
      const scrollContainer = this.el.nativeElement.querySelector('.scroll-container');
      this.renderer.setStyle(scrollContainer, 'height', '72vh');
    }
    else {
      const scrollContainer = this.el.nativeElement.querySelector('.scroll-container');
      this.renderer.setStyle(scrollContainer, 'height', '22vh');
    }
  }  
  
  displayStaffMember(staffMember: any): string {
    if (staffMember) {
        if (staffMember.id === 0) {
            return staffMember.firstName;
        } else {
            return `${staffMember.id}: ${staffMember.firstName} ${staffMember.lastName}`;
        }
    } else {
        return '';
    }
  }
}

